import React, { Fragment, useState } from 'react';
import styles from './import-role.module.css';
import classNames from 'classnames';
import { SelectRoleLayout } from './select-role.layout';
import { colourString, Button, Panel } from '@keplerco/core';
import { CompanyRoleListItemResponse } from '../../../../../../models/overmind/company-entity';
import { AstronautsIcon } from '../../../../../../design/icons/astronauts.icon';

export function ImportRoleLayout({ selectedRole, error, setSelectedRole }: { selectedRole: CompanyRoleListItemResponse | undefined; error: boolean; setSelectedRole: (role: CompanyRoleListItemResponse | undefined) => void }): JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <div className={classNames('card', styles.container)}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <h3>Role details</h3>
          <p style={{ color: colourString('text_1') }}>Define job roles, assign essential skills, and set performance standards.</p>
        </div>

        <div className="card action-card">
          <AstronautsIcon />

          <div className="action-card-content">
            <h3>Search for a role</h3>
            <p>Search global competency frameworks to find and import a role.</p>
          </div>

          <Button type="button" onClick={() => setOpen(true)}>
            Search
          </Button>
        </div>

        <div className={classNames('formErrorMessage', { invisible: !error })}>Please select a role to continue</div>
      </div>

      <Panel open={open} onClose={() => setOpen(false)}>
        <SelectRoleLayout
          onBack={() => setOpen(false)}
          setSelectedRole={role => {
            setSelectedRole(role);
            setOpen(false);
          }}
          selectedRole={selectedRole}
        />
      </Panel>
    </Fragment>
  );
}
